import i18next from 'i18next';

export const REFERRAL = {
  getText: () => i18next.t('FEATURE.REFERRAL.REFERRAL'),
  path: 'https://support.inpulse.ai/fr/articles/8115995-recommandez-inpulse-a-d-autres-enseignes',
  icon: '/images/referral.svg',
  isExternalLink: true,
};
